import React from 'react';

const Copyright: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <div className="card">
      <div className="card-header">
        <h5 className="mb-0">Copyright</h5>
      </div>
      <div className="card-body">
        <p className="mb-0">© {year} Travancore Devaswom Board. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Copyright;
